let angularScope;

const getAngularScope = () => {
    // eslint-disable-next-line no-undef
    if (!window.angular) return;
    if (!angularScope) {
        // eslint-disable-next-line no-undef
        angularScope = angular.element('body').scope();
    }

    return angularScope;
};

export const isAngular = () => !!window.angular && angular.element('body').injector();

export const getAngularProvider = (provider) => {
    // eslint-disable-next-line no-undef
    return angular.element('body').injector().get(provider);
};

export const getAngularRootScope = () => getAngularScope()?.$root;

export const subscribeToAngularEvent = (event, callback) => {
    if (!window.angular) return;

    // wait for the page to finish loading before subscribing to the event
    angular.element(document).ready(() => {
        const angularRootScope = getAngularRootScope();
        if (!angularRootScope) return;

        angularRootScope.$on(event, callback);
    });
};

export const emitAngularEvent = (event, payload) => {
    const angularRootScope = getAngularRootScope();
    if (!angularRootScope) return;

    angularRootScope.$broadcast(event, payload);
};

export const safeDigest = () => {
    if (!window.angular) return;
    const scope = getAngularScope();
    if (scope && !scope.$$phase) {
        scope.$digest();
    }
};
